<template>
	<div class="tns-carousel-outer">
		<div class="tns-carousel" ref="slider">
			<div
				v-for="(item, index) in list"
				:key="item.id"
				class="tns-carousel__item"
				v-if="item.position"
				:data-index="index"
			>
				<router-link
					:to="{
						name: POSITION_PAGE_NAME,
						params: { slug: item.position.slug }
					}"
				>
					<article
						class="position-item"
						:class="
							`position-item--${item.position.departments[0].color}`
						"
					>
						<div class="tile-background"></div>
						<div class="tile-content-wrapper">
							<h4 class="heading">{{ item.position.title }}</h4>
							<div class="tile-body">
								<div class="paragraph">
									<h6>Location</h6>
									<p class="location">
										{{ item.position.location.city }},
										{{ item.position.location.country }}
									</p>
								</div>
								<div class="paragraph">
									<h6>Disciplines</h6>
									<p class="location">
										{{ item.position.departments[0].name }}
									</p>
								</div>
							</div>
							<a href="#" class="text-semi-bold apply"
								>Apply Now
								<i
									class="icons8-arrow-right-slider--01 icon"
								></i
							></a>
						</div>
						<div class="hover-shadow"></div>
					</article>
				</router-link>
			</div>
		</div>
		<div ref="arrows" class="tns-carousel-arrows">
			<button class="button prev">
				<i class="icons8-arrow-left-slider--01"></i>
			</button>
			<button class="button next">
				<i class="icons8-arrow-right-slider--01"></i>
			</button>
		</div>

		<div class="divider"></div>
		<div class="text-center">
			<div class="separator"></div>
			<basic-button to="/positions" type="black-bordered"
				>View More jobs</basic-button
			>
			<div class="separator"></div>
		</div>
	</div>
</template>

<script>
import { tns } from "tiny-slider/src/tiny-slider.module";
import { POSITION_PAGE_NAME } from "../../router/pageConstants";
import BasicButton from "../BasicButton";
import BiButton from "@bistudio/bohemia-vue-components/dist/BiButton";
import "@bistudio/bohemia-vue-components/dist/BiButton/BiButton.css";

export default {
	name: "positions-slider",
	components: {
		BasicButton,
		BiButton
	},
	props: {
		list: {
			type: Array
		}
	},
	computed: {},
	data() {
		return {
			slider: null,
			activeSlide: 0,
			POSITION_PAGE_NAME /**/
		};
	},
	methods: {
		goToSlide(index) {
			this.slider.goTo(index);
		}
	},

	mounted() {
		console.log(this.list);
		let options = {
			container: this.$refs.slider,
			items: 1,
			loop: false,
			gutter: 23,
			nav: false,
			controlsContainer: this.$refs.arrows,
			responsive: {
				768: {
					items: 2
				},
				1024: {
					items: 3
				}
			}
		};
		this.slider = tns(options);

		this.slider.events.on("indexChanged", info => {
			console.log("visible" + info.visibleNavIndexes);
		});
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/globals";

.tile-body {
	.paragraph {
		width: 100%;

		h6 {
			font-family: Montserrat, sans-serif;
			font-weight: 300;
			font-size: 16px;
			letter-spacing: 0.36px;
			margin-bottom: 10px;
		}

		p {
			font-family: Montserrat, sans-serif;
			font-weight: 400;
			font-size: 16px;
			letter-spacing: 0.36px;
		}

		.location {
			font-family: Montserrat, sans-serif;
			font-weight: 700;
			font-size: 18px;
			letter-spacing: 0.9px;
		}
	}
}

.tns-carousel-outer {
	position: relative;
}

.tns-carousel-arrows {
	.prev,
	.next {
		position: absolute;
		top: 42%;
		transform: translateY(-50%);
		font-size: 40px;
		padding: 10px;
	}

	.prev {
		left: -32px;
	}

	.next {
		right: -32px;
	}
}

.tns-carousel-dots {
	margin-top: 2em;
	display: flex;
	justify-content: center;

	button {
		width: 1em;
		height: 1em;
		border-radius: 50%;
		background-color: #f1f1f2;
		margin: 0 0.2em;

		&.tns-nav-active {
			background-color: #bbbdbf;
		}
	}
}

.position-item {
	overflow: hidden;

	.tile-content-wrapper {
		position: relative;
		height: 100%;
		width: 100%;
		z-index: 6;
		padding: 42px 30px;

		a {
			transition: all 0.3s ease-out;
		}
	}

	.hover-shadow {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		z-index: 5;
		opacity: 0;
		background: #000;
		transition: opacity 0.8s ease-out;
	}

	position: relative;
	height: 470px;
	color: #fff;
	font-family: $font-header;

	.tile-background {
		width: 100%;
		height: 100%;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		position: absolute;
		background: #4c4c4c url("/static/img/bg-position-item.png") center
			no-repeat;
		background-size: cover;
		transition: all 0.68s ease-out;
		overflow: hidden;
	}

	&:hover {
		.tile-background {
			transform: scale(1.1);
		}

		background-size: 110% 110%;

		a {
			color: #fff;
		}

		.hover-shadow {
			opacity: 0.3;
		}
	}

	@media (max-width: $compact) {
		padding: 0px 0px;
	}

	.heading {
		margin: 0 0 21px;
		line-height: 38px;
		letter-spacing: 0.78px;
		font-weight: 800;
		font-family: Montserrat, sans-serif;
		font-size: 32px;
		word-wrap: break-word;
		min-height: 175px;
		@media (max-width: 375px) {
			font-size: 30px;
		}
		@media (max-width: 1200px) {
			font-size: 32px;
		}
	}

	.paragraph {
		margin: 0;
		font-size: 16px;
		line-height: 1.32;
		letter-spacing: 0.36px;
		color: white !important;

		margin-bottom: 34px;
	}

	a {
		color: $text-strong;
		font-family: $font-paragraphs;
		font-size: 17px;
		position: absolute;
		bottom: 26px;
		right: 38px;
		letter-spacing: 0.12px;
	}
}

.generic-image {
	position: absolute;
	bottom: 35px;
	left: 50px;
}

// Discipline color coding
.position-item--1 {
	.tile-background {
		background-color: #f44d52;
	}
}

.position-item--2 {
	.tile-background {
		background-color: #f01459;
	}
}

.position-item--3 {
	.tile-background {
		background-color: #9300bb;
	}
}

.position-item--4 {
	.tile-background {
		background-color: #401587;
	}
}

.position-item--5 {
	.tile-background {
		background-color: #02b5f2;
	}
}

.position-item--6 {
	.tile-background {
		background-color: #00a3ad;
	}
}

.position-item--7 {
	.tile-background {
		background-color: #16bb7c;
	}
}

.position-item--8 {
	.tile-background {
		background-color: #fdc209;
	}
}

.position-item--9 {
	.tile-background {
		background-color: #ff8125;
	}
}

.position-item--10 {
	.tile-background {
		background-color: #607d8b;
	}
}

.position-item--11 {
	.tile-background {
		background-color: #353535;
	}
}

.position-item--12 {
	.tile-background {
		background-color: #6e0031;
	}
}

.position-item--13 {
	.tile-background {
		background-color: #151a93;
	}
}

.apply {
	color: white !important;
}

/deep/ .icon {
	&:hover {
		margin-left: 15px;
		transition: all 3s;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/sliders/JobsPositionsSlider.vue